export const COURSE_FORMAT = {
  SPOC: 'spoc',
  FOCUS: 'focus',
  MOOC: 'mooc',
}
